
// "Bönan" — CoffeeNova's green-brown bean mark. Central definition so every
// place that shows it (QR codes, homepage header) points at the same asset.
export const BEAN_LOGO_URL = 'https://safpfosbbrqmexlhjrth.supabase.co/storage/v1/object/public/products/kf737id6r3r-1768334763932.jpg';
